import React from "react";
import Image from "components/image";
import RichText from "components/rich-text";

const HeroText = (props) => {
	const { content, image } = props.data;
	return (
		<div className="w-full bg-[#F6F8F8] flex flex-col-reverse lg:flex-row">
			<div className="w-full lg:w-[60%]">
				<Image image={image?.asset} alt={image?.alt} className="w-full" />
			</div>
			<div className="w-full mx-auto lg:mt-10 lg:w-[40%] lg:p-5 my-5 text-center p-0 z-5 flex flex-col items-center justify-center">
				<RichText value={content}/>
			</div>
		</div>
	);
};

export default HeroText;
